<template>
    <div>
       <HeaderTeam header="ทีมงานของฉัน" :img_header="header_image" link_back="team"/>
       <MenuMyTeamList/>
       <AddTeamList/>
    </div>
</template>

<script>
import HeaderImage from '@/assets/icon-team.png'
import HeaderTeam from '@/components/menuadmin/team/teamheader/HeaderTeam.vue'
import MenuMyTeamList from '@/components/menuadmin/team/myteam/MenuMyTeamList.vue'
import AddTeamList from '@/components/menuadmin/team/myteam/AddTeamList.vue'
export default {
    name:'addTeam',
    components:{
        HeaderTeam,
        MenuMyTeamList,
        AddTeamList,
    },
    data(){
        return{
            header_image:HeaderImage
        }
    }
}
</script>